/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
import './OfferSearchFiltersMainView.css';

import React, { RefObject, useCallback, useEffect, useRef, useState } from 'react';
import throttle from 'lodash/throttle';
// import Icon from '@vtblife/uikit-icons';
import {
    Modal as DSModal,
    // Typography
} from '@vtblife/uikit';

import classname from '@search/classname/src';
import { RootRegionsApplicationEnum } from '@search/graphql-typings';

import { Filters, IFilter, RegionFilter } from '@search/vtbeco-frontend-core/view/filters/models/Filter';
import { DesktopLandStatusFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/landStatus/DesktopLandStatusFilterView';
import { DesktopRoomsTypeNewFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/rooms/DesktopRoomsTypeNewFilterView';
import { DesktopHouseTypeFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/houseType/DesktopHouseTypeFilterView';
import { DesktopPriceFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/price/DesktopPriceFilterView';
import { DesktopGeoFiltersView2 } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/geo/DesktopGeoFiltersView2';
import { DesktopDealTypeFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/deal_type/DesktopDealTypeFilterView';
import { DesktopRealtyTypeFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/realty_type/DesktopRealtyTypeFilterView';
import { DesktopNewBuildingTypeFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/new_building/DesktopNewBuildingTypeFilterView';
import { ClassifiedFilterUi } from '@search/vtbeco-frontend-core/domain/offer/filters/ClassifiedFilterUi';
import { ClassifiedFilterCollection } from '@search/vtbeco-frontend-core/domain/offer/filters/ClassifiedFilterCollection';
import { AddQueryDisplayValue } from '@search/vtbeco-frontend-core/view/common/hooks/useQueryDisplayValues';
import { getPriceTypes } from '@search/vtbeco-frontend-core/view/common/components/CommonSearchFilterPanel/CommonSearchFilterPanel';
import { RealtyObjectType, DealType } from '@search/filter-enums/enums';
import { GeoBaseStore } from '@search/vtbeco-frontend-core/domain/geo/GeoBase';
// import { useClassifiedOfferDataLayerPush } from '@search/vtbeco-frontend-core/domain/offer/analytics/ClassifiedOfferGtmContext';
import { useGeoRootRegion } from '@search/geo/src/GeoRootRegionProvider';
import { useToggleChain } from '@search/vtbeco-frontend-core/view/common/components/Price/popper/useToggleChain';
import { RegionSelector2 } from '@search/classified-common/src/RegionSelector2/RegionSelector2';
import { FilterMapAreaPaneDesktop } from '@search/vtbeco-frontend-core/domain/offer/ymap/FilterMapArea/FilterMapAreaPaneDesktop';
import RegionSwitch from '@search/vtbeco-frontend-core/view/common/components/RegionSwitch';
import { IRegion } from '@search/geo/src/geoRootRegionFallback';

const cn = classname.bind(null, 'OfferSearchFiltersMainView');
const cnHidden = cn('sticky', { hidden: true }).split(' ')[1];
const cnAnimationOn = cn('sticky', { transitionDuration: true }).split(' ')[1];
const cnSticky = cn('sticky', { stucked: true }).split(' ')[1];
const cnShadow = cn('sticky', { shadow: true }).split(' ')[1];

function getEnabledSegments(dealType: DealType) {
    if (dealType === DealType.RENT) {
        return [ RealtyObjectType.FLAT, RealtyObjectType.ROOM, RealtyObjectType.HOUSE ];
    }

    return [ RealtyObjectType.FLAT, RealtyObjectType.ROOM, RealtyObjectType.LAND, RealtyObjectType.HOUSE ];
}

function getEnabledDealType(categoryType: RealtyObjectType) {
    if (categoryType === RealtyObjectType.LAND) {
        return [ DealType.SELL ];
    }

    return [ DealType.SELL, DealType.RENT ];
}

interface IOfferSearchFiltersMainViewProps {
    geoStore: GeoBaseStore;
    count: number;
    filters: ClassifiedFilterCollection;
    more: React.ReactNode;
    buttonSubmit: React.ReactNode;
    updateFilter: (filter: IFilter) => void;
    updateFewFilters: (filter: IFilter[]) => void;
    tips?: React.ReactElement;
    addQueryDisplayValue: AddQueryDisplayValue;
    onSaveSearch: () => void;
    serpContentRef: RefObject<HTMLElement | null>;
    setTipsExpanded: (expanded: boolean) => void;
    lastSearches: React.ReactNode;
    regionId: number;
    rootRegion?: IRegion;
}

export const OfferSearchFiltersMainView: React.FC<IOfferSearchFiltersMainViewProps> = ({
    geoStore,
    count,
    filters,
    more,
    buttonSubmit,
    updateFilter,
    updateFewFilters,
    tips,
    addQueryDisplayValue,
    // onSaveSearch,
    serpContentRef,
    setTipsExpanded,
    lastSearches,
    regionId,
    rootRegion
}) => {
    // const dataLayerPush = useClassifiedOfferDataLayerPush();
    const rootRegions = useGeoRootRegion();

    const isHiddenRef = useRef(false);
    const stickyWrapperRef = useRef<HTMLDivElement>(null);
    const scrollTopPosition = useRef(0);
    const startPointAlgorithm = serpContentRef.current?.offsetTop ?? 300;
    const endStickyPointAlgorithm = startPointAlgorithm - (stickyWrapperRef.current?.offsetHeight ?? 0);
    const [ isHeaderVisible, setHeaderVisible ] = useState(false);

    const [ isMapArea, setIsMapArea ] = React.useState(false);
    const showMapArea = useCallback(() => {
        setIsMapArea(true);
    }, []);
    const closeMapArea = useCallback(() => {
        setIsMapArea(false);
    }, []);

    const handleScroll = useCallback(() => {
        const wrapper = stickyWrapperRef.current;

        if (! wrapper) return;
        const classList = wrapper.classList;

        const needActivateAlgorithm = document.documentElement.scrollTop > startPointAlgorithm;
        const isOvercomeThrottleWeight = Math.abs(scrollTopPosition.current - document.documentElement.scrollTop) >= 150;
        const needHideShadow = document.documentElement.scrollTop <= startPointAlgorithm;
        const needDisableSticky = document.documentElement.scrollTop <= endStickyPointAlgorithm;
        const needHide = scrollTopPosition.current < document.documentElement.scrollTop && needActivateAlgorithm;

        if (needHide && ! isHiddenRef.current && isOvercomeThrottleWeight) {
            setTipsExpanded(false);
            isHiddenRef.current = true;
            classList.add(cnHidden);
            setHeaderVisible(false);
        }

        if (needActivateAlgorithm) {
            setTipsExpanded(false);
            // design
            // чтобы когда мы проставим в первый раз hidden не сработала анимация с 0 до -100%
            // чтобы при изначальном скролле не закреплялась шапка, только при обратном скролле
            setTimeout(() => classList.add(cnAnimationOn), 0);
        } else {
            classList.remove(cnAnimationOn);
        }

        if (! needHide && isHiddenRef.current && isOvercomeThrottleWeight) {
            isHiddenRef.current = false;
            classList.remove(cnHidden);
            setHeaderVisible(true);
        }

        if (needDisableSticky) {
            classList.remove(cnSticky);
        }

        if (needHideShadow) {
            classList.remove(cnShadow);
        } else {
            classList.add(cnShadow);
            classList.add(cnSticky);
        }

        if (isOvercomeThrottleWeight) {
            scrollTopPosition.current = document.documentElement.scrollTop;
        }
    }, [ startPointAlgorithm, setTipsExpanded, endStickyPointAlgorithm ]);

    useEffect(() => {
        const throttledHandleScroll = throttle(handleScroll, 250);

        window.addEventListener('scroll', throttledHandleScroll);

        return () => {
            window.removeEventListener('scroll', throttledHandleScroll);
        };
    }, [ handleScroll ]);

    const spySuggest = useToggleChain({
        enterTimeout: 250,
        leaveTimeout: 250
    });

    return (<>
        <div className={cn('white-bg', undefined, 'colored-app-paddings')}>
            <RegionSwitch regionId={regionId} rootRegion={rootRegion} isHeaderVisible={isHeaderVisible} />
            <div className={cn('top-panel')}>
                <div className={cn('top-panel-filters')}>
                    <div className={cn('top-panel-item')}>
                        <DesktopDealTypeFilterView
                            filter={filters.get(Filters.dealType)}
                            enabledItems={getEnabledDealType(filters.getCategoryTypeFilter().categoryType)}
                            onChange={updateFilter}
                        />
                    </div>
                    <div className={cn('top-panel-item')}>
                        <DesktopRealtyTypeFilterView
                            filter={filters.get(Filters.categoryType)}
                            enabledSegments={getEnabledSegments(filters.getDealTypeFilter().dealType)}
                            onChange={updateFilter}
                        />
                    </div>
                    {
                        filters.isNewBuildingShown() && filters.get(Filters.newBuilding) &&
                        <div className={cn('top-panel-item')}>
                            <DesktopNewBuildingTypeFilterView
                                filter={filters.get(Filters.newBuilding)}
                                onChange={updateFilter}
                            />
                        </div>
                    }
                    <div className={cn('top-panel-item')}>
                        <RegionSelector2
                            selectedId={(filters.get(Filters.region) as RegionFilter).region}
                            items={rootRegions.items}
                            onSelectId={id => updateFilter(new RegionFilter(id))}
                            dropdown
                        />
                    </div>
                </div>
                {/*<div onClick={() => {*/}
                {/*    onSaveSearch();*/}
                {/*    dataLayerPush({ event: 'classified_serp_click_save_search' });*/}
                {/*}} data-test='save-search-filters' className={cn('save-search-wrap')}>*/}
                {/*    <Icon name='magnifier-heart' color='#3216B5' />*/}
                {/*    <Typography*/}
                {/*        tag='span'*/}
                {/*        variant='secondary-alone'*/}
                {/*        color='link'*/}
                {/*        className={cn('save-search')}*/}
                {/*    >Сохранить поиск </Typography>*/}
                {/*</div>*/}
            </div>
        </div>
        <div className={cn('sticky', undefined, 'colored-app-paddings')} ref={stickyWrapperRef}>
            <div className={cn('max-width')}>
                <div className={cn('bottom-panel')}>
                    <div style={{ display: 'flex' }}>
                        {
                            filters.isLandFilterActive() &&
                            <div className={cn('land-status')}>
                                <DesktopLandStatusFilterView
                                    filter={filters.get(Filters.landStatus)}
                                    onChange={updateFilter}
                                />
                            </div>
                        }
                        {
                            filters.isFlatFilterActive() &&
                            <div className={cn('rooms')}>
                                <DesktopRoomsTypeNewFilterView
                                    filter={filters.get(Filters.rooms)}
                                    kitchenAreaFilter={filters.get(Filters.kitchenArea)}
                                    onChange={updateFilter}
                                    isRent={filters.isRentFilterActive()}
                                />
                            </div>
                        }
                        {
                            filters.isHouseFilterActive() &&
                            <div className={cn('house')}>
                                <DesktopHouseTypeFilterView
                                    filter={filters.get(Filters.houseCategory)}
                                    onChange={updateFilter}
                                />
                            </div>
                        }
                        <div className={cn('price', { pricewide: filters.isRoomFilterActive() })}>
                            <DesktopPriceFilterView
                                filter={filters.get(Filters.price)}
                                mortgagePaymentFilter={filters.get(Filters.mortgagePayment)}
                                priceTypes={getPriceTypes(filters)}
                                pricePreset={ClassifiedFilterUi.getPricePreset(filters)}
                                onChange={updateFilter}
                                updateFewFilters={updateFewFilters}
                                inputBorderSide={filters.isRoomFilterActive() ? 'rounded_square' : 'square'}
                            />
                        </div>
                        <div className={cn('geo', { geowide: filters.isRoomFilterActive() })}>
                            <DesktopGeoFiltersView2
                                spySuggest={spySuggest}
                                showNewBuildingsGroup={
                                    filters.getCategoryTypeFilter().categoryType === RealtyObjectType.FLAT
                                }
                                className={cn('geo-position')}
                                geoStore={geoStore}
                                count={count}
                                filters={filters}
                                onChange={updateFewFilters}
                                rootRegionsApp={RootRegionsApplicationEnum.OffersSerp}
                                addQueryDisplayValue={addQueryDisplayValue}
                                inputBorderSide='square_rounded'
                                showMapArea={showMapArea}
                                isClGeoFilter
                            />
                        </div>
                    </div>
                    {more}
                    {buttonSubmit}
                </div>
                {tips}
                {isHiddenRef.current ? null : (
                    <div className={cn('last-searches')}>
                        {lastSearches}
                    </div>
                )}
                {isMapArea && (
                    <DSModal
                        size='xl'
                        opened
                        closable={false}
                    >
                        <DSModal.WideContent header footer>
                            <div style={{ height: '95vh' }}>
                                <FilterMapAreaPaneDesktop
                                    updateFilter={updateFilter}
                                    showOffers={closeMapArea}
                                    countInitial={count}
                                    filters={filters}
                                    onClose={closeMapArea}
                                />
                            </div>
                        </DSModal.WideContent>
                    </DSModal>
                )}
            </div>
        </div>
    </>);
};
